"use client";

import { Program } from "@faire/slate/foundation/color";
import { legacyIconCls } from "@faire/web/slate/utils/tracking";
import React from "react";

import { SVGIcon } from "./SVGIcon";
import { createSVGIcon } from "./util";

/** @optimized using svgo:^3.0.2 */
const InsiderIcon = createSVGIcon(
  <path
    d="M20.017 14.37H25m-12.226-3.62H25m-12.176.75c0 3.038-2.423 5.5-5.412 5.5C4.422 17 2 14.538 2 11.5S4.423 6 7.412 6s5.411 2.462 5.411 5.5Z"
    stroke="currentColor"
    strokeWidth="2.5"
  />,
  "Insider",
  {
    viewBox: "0 0 24 24",
    titleAccess: "Insider",
    fill: "none",
    width: "24",
    height: "auto",
    color: Program.icon.insider,
    className: legacyIconCls(),
  }
);

/** @optimized using svgo:^3.0.2 */
const SmallInsiderIcon = createSVGIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8.874 8A4.002 4.002 0 0 1 1 7a4 4 0 0 1 7.874-1H15v3.75h-3V8zM5 9.222a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444"
    fill="currentColor"
  />,
  "Insider",
  {
    viewBox: "0 0 16 16",
    titleAccess: "Insider",
    width: "16",
    height: "auto",
    color: Program.icon.insider,
    className: legacyIconCls(),
  }
);

/**
 * @trackcomponent
 */
export const Insider = React.memo(
  ({
    small,
    ...props
  }: SVGIcon.IProps & {
    small?: boolean;
  } & React.RefAttributes<SVGElement>) => {
    return small ? <SmallInsiderIcon {...props} /> : <InsiderIcon {...props} />;
  }
);
